import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FilterBudgetCalculation } from "../models/filters/filter-budget-calculation";

@Injectable({
    providedIn: 'root'
  })
  export class BudgetCalculationService {
  
    constructor(private http: HttpClient) { }
  
    private apiUrl = `${environment.apiUrl}`;
    private url: string = this.apiUrl + 'api/budget'; 
  
    budgetCalculation(filterBudgetCalculation: FilterBudgetCalculation): Observable<Blob> {
        return this.http.post(`${this.url}/budgetCalculation`, filterBudgetCalculation, {
          responseType: 'blob'
        });
      }
  }